export default __webpack_public_path__ + "static/media/logo-black.756e45a4.png";